// extracted by mini-css-extract-plugin
module.exports = {"title":"combinations__title___2u-oZ","container":"combinations__container___27H-M","error":"combinations__error___1wflJ"};